import { render, staticRenderFns } from "./Kenya.vue?vue&type=template&id=ebc72974&scoped=true&"
import script from "./Kenya.vue?vue&type=script&lang=js&"
export * from "./Kenya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc72974",
  null
  
)

export default component.exports